import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import LazyLoader from "../components/LazyLoader";
import Login from "../pages/login/Login";
import PasswordSet from "../pages/login/PasswordSet";
import PrivateRoute from "../components/PrivateRoute";
import NotFound from "../pages/not-found/NotFound";
import { useSelector } from "react-redux";
import NavbarContentList from "../pages/NavbarContent/NavbarContentList";
import AddEditNavbarContent from "../pages/NavbarContent/AddEditNavbarContent";
import ViewNavbarContent from "../pages/NavbarContent/ViewNavbarContent";
import LegalContentList from "../pages/LegalContent/LegalContentList";
import AddEditLegalContent from "../pages/LegalContent/AddEditLegalContent";
import PreviewLegalContent from "../pages/LegalContent/PreviewLegalContent";
import CrmSuperAdminDashboard from "../pages/crm-website-super-admin/CrmSuperAdminDashboard";
import ContactEnquiryList from "../pages/crm-website-super-admin/contact-us-enquiries/ContactEnquiry";
import FooterContentList from "../pages/crm-website-super-admin/FooterContent/FooterContentList";
import CreateFooterContent from "../pages/crm-website-super-admin/FooterContent/CreateFooterContent";
import ProposalTerms from "../pages/proposal/proposal-terms/ProposalTerms";
import TermsEditor from "../pages/proposal/proposal-terms/TermsEditor";
import EmailEditor from "../pages/bulk-message/components/EmailEditor";
import EmailPreview from "../pages/bulk-message/components/EmailPreview";
import PaymentDetails from "../pages/proposal/PaymentDetails";
import LeadConfiguration from "../pages/admin/LeadConfiguration";
import AdmissionForm from "../pages/Admission/AdmissionForm";
import AdmissionDashboard from "../pages/Admission/AdmissionDashboard";
import AddAccount from "../pages/Accounts/AddAccount";
import AccountList from "../pages/Accounts/AccountList";
import AdmissionList from "../pages/Admission/AdmissionList";
import ViewAdmission from "../pages/Admission/ViewAdmission";
import AdmissionRouteGuard from "../components/AdmissionRouteGuard";

// import ProposalPage from "../pages/proposal/Proposal";
// import ProposalList from "../pages/proposal/ProposalList";
// import EditorComponent from "../pages/proposal/ProposalEditor";
// import ProposalView from "../pages/proposal/ProposalView";
// import ProposalGreeting from "../pages/proposal/ProposalGreeting";

const ProposalPage = lazy(() => import("../pages/proposal/Proposal"));
const ProposalList = lazy(() => import("../pages/proposal/ProposalList"));
// const EditorComponent = lazy(() => import("../pages/proposal/ProposalEditor"));
const ProposalView = lazy(() => import("../pages/proposal/ProposalView"));
const ProposalGreeting = lazy(
  () => import("../pages/proposal/ProposalGreeting"),
);
const ProposalGreetingTemplateEditor = lazy(
  () => import("../pages/proposal/components/GreetingTemplateEditor"),
);

// lazy load components
const AddnewUser = lazy(() => import("../pages/user/AddnewUser"));
const AddnewAdmin = lazy(() => import("../pages/user/AddAdmin"));
const TeamList = lazy(() => import("../pages/user/TeamList"));
const AdminList = lazy(() => import("../pages/user/AdminList"));
const AdminIntegrationSettings = lazy(
  () => import("../pages/user/AdminIntegrationSettings"),
);

const LeadFilter = lazy(() => import("../pages/leads/components/LeadFilter"));

const SourceList = lazy(() => import("../pages/source/SourceList"));
const AddNewLead = lazy(() => import("../pages/leads/AddNewLead"));
const AddSource = lazy(() => import("../pages/source/AddSource"));
const CourseList = lazy(() => import("../pages/course/CourseList"));
const AddCourse = lazy(() => import("../pages/course/AddCourse"));
const BranchList = lazy(() => import("../pages/branch/BranchList"));
const CityList = lazy(() => import("../pages/city/CityList"));
const AddStatus = lazy(() => import("../pages/status/AddStatus"));
const StatusList = lazy(() => import("../pages/status/StatusList"));
const AddBasicInfo = lazy(() => import("../pages/user/AddBasicInfo"));
const AddBranch = lazy(() => import("../pages/branch/AddBranch"));
const AddCity = lazy(() => import("../pages/city/AddCity"));
const UpdateCourse = lazy(() => import("../pages/course/UpdateCourse"));
const UpdateBranch = lazy(() => import("../pages/branch/UpdateBranch"));
const UpdateSource = lazy(() => import("../pages/source/UpdateSource"));
const UpdateCity = lazy(() => import("../pages/city/UpdateCity"));
const UpdateTemplate = lazy(() => import("../pages/WhatsApp/UpdateMessage"));
const UpdateStatus = lazy(() => import("../pages/status/UpdateStatus"));
const LeadList = lazy(() => import("../pages/leads/LeadList"));
const UpdateUser = lazy(() => import("../pages/user/UpdateUser"));
const UpdateAdmin = lazy(() => import("../pages/user/UpdateAdmin"));
const UserDashboard = lazy(() => import("../pages/dashboard/UserDashboard"));
const SuperDashboard = lazy(() => import("../pages/dashboard/SuperDashboard"));
const AdminDashboard = lazy(() => import("../pages/dashboard/AdminDashboard"));
const Profile = lazy(() => import("../pages/Profile/Profile"));
const NotificationsPage = lazy(
  () => import("../pages/notifications/NotificationsPage"),
);
const Support = lazy(() => import("../pages/support/Support"));
const SuperSupport = lazy(() => import("../pages/support/SuperSupport"));
const WhatsAppMsg = lazy(() => import("../pages/WhatsApp/Message"));
const WhatsAppImg = lazy(() => import("../pages/WhatsApp/Image"));
const WhatsAppDocs = lazy(() => import("../pages/WhatsApp/Documents"));
const WhatsAppAddMsg = lazy(() => import("../pages/WhatsApp/AddMessage"));
const WhatsAppAddImg = lazy(() => import("../pages/WhatsApp/AddImage"));
const WhatsAppAddDocs = lazy(() => import("../pages/WhatsApp/AddDocuments"));
const SocialIntegration = lazy(
  () => import("../pages/SocialIntegration/SocialIntegration"),
);

const IndiaMart = lazy(() => import("../pages/IndiaMart/IndiaMart"));
const AdminDetails = lazy(() => import("../pages/user/AdminDetails"));
const UserDetails = lazy(() => import("../pages/user/UserDetails"));
const UpdateTicket = lazy(() => import("../pages/support/UpdateTicket"));

const Unauthorized = lazy(() => import("../pages/Unauthorized/Unauthorized"));
const SideMenu = lazy(() => import("../pages/SideMenu/SideMenu"));
const UpdateSideMenu = lazy(() => import("../pages/SideMenu/Update"));

const BulkDashborad = lazy(
  () => import("../pages/bulk-message/BulkMessageDashboard"),
);

const MarketingDashboard = lazy(
  () => import("../pages/bulk-message/MarketingDashboard"),
);
const EmailTemplates = lazy(
  () => import("../pages/bulk-message/components/EmailTemplates"),
);

const EmailTemplateEditor = lazy(
  () => import("../pages/bulk-message/components/EmailTemplateEditor"),
);
const EmailAnalytics = lazy(
  () => import("../pages/bulk-message/components/EmailCampaignAnalytics"),
);

const WhatsAppTemplates = lazy(
  () => import("../pages/bulk-message/components/whatsApp/WhatsAppTemplate"),
);
const WhatsAppTemplateEditor = lazy(
  () =>
    import("../pages/bulk-message/components/whatsApp/WhatsAppTemplateEditor"),
);
const SmsTemplates = lazy(
  () => import("../pages/bulk-message/components/sms/SmsTemplates"),
);
const SmsTemplateEditor = lazy(
  () => import("../pages/bulk-message/components/sms/SmsTemplateEditor"),
);
const DemoEnquiry = lazy(() => import("../pages/demo-enquiry/DemoEnquiryList"));
const DoveSoftDashboard = lazy(() => import("../pages/dove-soft/DoveSoftDashboard"));
const DoveSoftTemplates = lazy(() => import("../pages/dove-soft/DoveSoftTemplates"));
const DoveSoftCreateTemplate = lazy(() => import("../pages/dove-soft/DoveSoftCreateTemplate"));
const DoveSoftCampaign = lazy(() => import("../pages/dove-soft/DoveSoftCampaign"));
const DoveSoftReport = lazy(() => import("../pages/dove-soft/DoveSoftReport"));
const DoveSoftConfig = lazy(() => import("../pages/dove-soft/DoveSoftConfig"));
const AddNewEnquiry = lazy(() => import("../pages/demo-enquiry/AddNewEnquiry"));
const DemoViewPage = lazy(
  () => import("../pages/demo-enquiry/components/EnquiryViewPage"),
);
const SuperAdminUserList = lazy(
  () => import("../pages/super-admin-users/SuperAdminUserList"),
);
const AddnewSuperAdminuser = lazy(
  () => import("../pages/super-admin-users/AddSuperAdminUser"),
);
const UpdateSuperUser = lazy(
  () => import("../pages/super-admin-users/UpdateSuperUser"),
);

const AllRoutes = ({ isSideBar }) => {
  const { signinuser } = useSelector((state) => state.common);

  return (
    <Routes>
      {/* add routes */}
      <Route
        path="/"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Dashboard">
              <UserDashboard />
            </PrivateRoute>
          </Suspense>
        }
      />
       <Route
        path="/login"
        element={
          <Suspense fallback={<LazyLoader />}>
            <Login />
          </Suspense>
        }
      /> 
      <Route
        path="/password-set"
        element={
          // <Suspense fallback={<LazyLoader />}>
          <PasswordSet />
          // </Suspense>
        }
      />
      <Route
        path="/admin-dashboard"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Dashboard">
              <AdminDashboard />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/proposal"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <ProposalPage />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/demo-enquiry-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Enquiry List">
              <DemoEnquiry />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-new-enquiry"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Enquiry List">
              <AddNewEnquiry />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/proposal-view"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <ProposalView />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/proposal-greeting"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <ProposalGreeting />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/proposal-greeting-template-editor"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <ProposalGreetingTemplateEditor />
            </PrivateRoute>
          </Suspense>
        }
      />
       <Route
        path="/email-editor"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <EmailEditor />
            </PrivateRoute>
          </Suspense>
        }
      />
       <Route
        path="/email-preview"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <EmailPreview />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/lead-filter"
        element={
          <Suspense fallback={<LazyLoader />}>
            <LeadFilter />
          </Suspense>
        }
      />
      <Route
        path="/super-dashboard"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Dashboard">
              <SuperDashboard />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/profile"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute
              requiredPermissions={
                signinuser?.UserType === 1 ? "Enquiry List" : "Lead List"
              }
            >
              <Profile />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/notifications"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute
              requiredPermissions={
                signinuser?.UserType === 1 ? "Enquiry List" : "Lead List"
              }
            >
              <NotificationsPage />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/support"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <Support />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/super-support"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Support">
              <SuperSupport />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/sidemenu"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="SideMenu">
              <SideMenu />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/update-sidemenu"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="SideMenu">
              <UpdateSideMenu />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="lead-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Lead List">
              <LeadList isSideBar={isSideBar} />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="template"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <WhatsAppMsg />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="whatsapp-image"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <WhatsAppImg />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="whatsapp-document"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <WhatsAppDocs />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="integration"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <SocialIntegration />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="add-message"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <WhatsAppAddMsg />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="add-image"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <WhatsAppAddImg />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="add-document"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <WhatsAppAddDocs />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/addnewadmin"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions={"Admin List"}>
              <AddnewAdmin />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/addnewuser"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Team List">
              <AddnewUser />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/addnewSuperAdminuser"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Super Admin User List">
              <AddnewSuperAdminuser />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-source"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Source List">
              <AddSource />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-lead"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Lead List">
              <AddNewLead />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-course"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Product List">
              <AddCourse />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-branch"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Branch List">
              <AddBranch />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-basic-information"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute>
              <AddBasicInfo />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-city"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="City List">
              <AddCity />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/add-status"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Status List">
              <AddStatus />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/marketing-dashboard"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <MarketingDashboard />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/send-campaign/:type"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <BulkDashborad />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/create-template-email"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <EmailTemplates />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/email-template-editor"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <EmailTemplateEditor />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/analytics/email"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <EmailAnalytics />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/create-template-whatsApp"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <WhatsAppTemplates />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/whatsApp-template-editor"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <WhatsAppTemplateEditor />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/create-template-sms"
        element={
          <Suspense>
            <SmsTemplates />
          </Suspense>
        }
      />
      <Route
        path="/sms-template-editor"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Marketing">
              <SmsTemplateEditor />
            </PrivateRoute>
          </Suspense>
        }
      />
      {/* list routes  */}
      <Route
        path="/user-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Team List">
              <TeamList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/admin-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Admin List">
              <AdminList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/admin-integration-settings/:adminId"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Admin List">
              <AdminIntegrationSettings />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/super-admin-user-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Super Admin User List">
              <SuperAdminUserList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/proposal-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <ProposalList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/payment-details/:id"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Proposal List">
              <PaymentDetails />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/source-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Source List">
              <SourceList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/product-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Product List">
              <CourseList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/branch-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Branch List">
              <BranchList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/city-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="City List">
              <CityList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/status-list"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="Status List">
              <StatusList />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/india-mart"
        element={
          <Suspense>
            <PrivateRoute requiredPermissions="India Mart">
              <IndiaMart />
            </PrivateRoute>
          </Suspense>
        }
      />
      {/* singlepage routes */}
      <Route
        path="admin-details/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Admin List">
              <AdminDetails />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="user-details/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Team List">
              <UserDetails />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-ticket/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Team List">
              <UpdateTicket />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-demo-enquiry/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Enquiry List">
              <DemoViewPage />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-course/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Product List">
              <UpdateCourse />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-branch/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Branch List">
              <UpdateBranch />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-source/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Source List">
              <UpdateSource />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-city/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="City List">
              <UpdateCity />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-template/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="City List">
              <UpdateTemplate />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-status/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Status List">
              <UpdateStatus />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-admin/id/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Admin List">
              <UpdateAdmin />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-user/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Team List">
              <UpdateUser />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="update-super-user/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <PrivateRoute requiredPermissions="Super Admin User List">
              <UpdateSuperUser />
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route path="/proposal-terms" element={<ProposalTerms />} />
      <Route path="/proposal-terms-editor" element={<TermsEditor />} />
      {/* crm website dynamic pages */}
      <Route
        path="/crm-super-admin-dashboard"
        element={<CrmSuperAdminDashboard />}
      />
      <Route path="/navbar-content-list" element={<NavbarContentList />} />
      <Route path="/navbar-content/add" element={<AddEditNavbarContent />} />
      <Route
        path="/navbar-content/edit/:id"
        element={<AddEditNavbarContent />}
      />
      <Route path="/navbar-content/view/:id" element={<ViewNavbarContent />} />
      <Route path="/legal-content-list" element={<LegalContentList />} />
      <Route path="/legal-content/add" element={<AddEditLegalContent />} />
      <Route path="/legal-content/edit/:id" element={<AddEditLegalContent />} />
      <Route
        path="/legal-content/preview/:id"
        element={<PreviewLegalContent />}
      />
      <Route path="/contact-enquiry-list" element={<ContactEnquiryList />} />
      <Route path="/footer-content-list" element={<FooterContentList />} />
      <Route path="/create-footer-content" element={<CreateFooterContent />} />
      <Route
        path="/edit-footer-content/:id"
        element={<CreateFooterContent />}
      />
      <Route path="/lead-field-config" element={<LeadConfiguration />} />

      {/* Dove Soft – WhatsApp Business Suite */}
      <Route
        path="/dove-soft"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftDashboard />
          </Suspense>
        }
      />
      <Route
        path="/dove-soft/templates"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftTemplates />
          </Suspense>
        }
      />
      <Route
        path="/dove-soft/templates/create"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftCreateTemplate />
          </Suspense>
        }
      />
      <Route
        path="/dove-soft/templates/edit/:id"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftCreateTemplate />
          </Suspense>
        }
      />
      <Route
        path="/dove-soft/campaign"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftCampaign />
          </Suspense>
        }
      />
      <Route
        path="/dove-soft/report"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftReport />
          </Suspense>
        }
      />
      <Route
        path="/dove-soft/config"
        element={
          <Suspense fallback={<LazyLoader />}>
            <DoveSoftConfig />
          </Suspense>
        }
      />

      {/* Admission module */}
      <Route
        path="/admission-dashboard"
        element={
          <AdmissionRouteGuard>
            <AdmissionDashboard />
          </AdmissionRouteGuard>
        }
      />
      <Route
        path="/admission-list"
        element={
          <AdmissionRouteGuard>
            <AdmissionList />
          </AdmissionRouteGuard>
        }
      />
      <Route
        path="/admission-form"
        element={
          <AdmissionRouteGuard>
            <AdmissionForm />
          </AdmissionRouteGuard>
        }
      />
      <Route
        path="/view-admission"
        element={
          <AdmissionRouteGuard>
            <ViewAdmission />
          </AdmissionRouteGuard>
        }
      />
      <Route
        path="/account-form"
        element={
          <AdmissionRouteGuard>
            <AddAccount />
          </AdmissionRouteGuard>
        }
      />
      <Route
        path="/account-list"
        element={
          <AdmissionRouteGuard>
            <AccountList />
          </AdmissionRouteGuard>
        }
      />

      <Route
        path="loader"
        element={
          // <Suspense fallback={<LazyLoader/>}>
          <LazyLoader />
          // </Suspense>
        }
      />
      <Route
        path="/unauthorized"
        element={
          <Suspense fallback={<LazyLoader />}>
            <Unauthorized />
          </Suspense>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AllRoutes;
